import dynamic from 'next/dynamic'

import LazyHydrate from 'react-lazy-hydration'

import { Theme, useMediaQuery } from '@mui/material'

import Box from 'app/components/base/Box'
import Center from 'app/components/base/Center'
import Container from 'app/components/base/Container'
import Spinner from 'app/components/base/Spinner'
import Breadcrumbs from 'app/components/common/Breadcrumbs'
import ArticleFeature from 'app/features/Blog/ArticleFeature'

import NextSeo from '~/containers/NextSeo'

import { useArticleView } from './hooks/useArticleView'

const RelevantArticles = dynamic(
  () => import('app/features/Blog/RelevantArticles'),
  { ssr: false }
)

const ArticleView = () => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'))

  const {
    title,
    blog_tags,
    body,
    breadcrumbsLinks,
    isPageLoading,
    hasArticle,
    seoDescription,
    created_at,
    title_image_url,
    imageAltText,
    shareLink,
    metaTitle
  } = useArticleView()

  return (
    <>
      <NextSeo
        title={title}
        description={seoDescription}
        openGraph={{
          title: metaTitle,
          description: seoDescription,
          images: [{ url: title_image_url }]
        }}
        {...(!hasArticle && { canonical: '404' })}
      />

      <Box component="section">
        <Container sx={{ pt: 5, pb: 10, maxWidth: { xs: '922px' } }}>
          <LazyHydrate whenIdle>
            <Breadcrumbs sx={{ mb: 4 }} items={breadcrumbsLinks} />
          </LazyHydrate>

          {isPageLoading && (
            <Center sx={{ height: '100vh' }}>
              <Spinner />
            </Center>
          )}

          {hasArticle && (
            <ArticleFeature
              title={title}
              image={title_image_url}
              body={body}
              createdAt={created_at}
              blogTags={blog_tags}
              imageAltText={imageAltText}
              shareLink={shareLink}
            />
          )}

          <LazyHydrate whenVisible>
            <RelevantArticles isMobile={isMobile} />
          </LazyHydrate>
        </Container>
      </Box>
    </>
  )
}

export default ArticleView
